<template>
	<div v-if="data">
		<div class="data-title">
			<h4 v-if="h4">{{label}}</h4>
			<h3 v-else>{{label}}</h3>
		</div>
		<div class="data-content data-clean text-content">
			<div v-html="data"></div>
		</div>
	</div>
</template>
<script>
export default {
	name: "datadisplay",
	props: {
		data: String,
		label: String,
		h4: Boolean
	}
};
</script>
<style scoped>
    .data-title h3 {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        color: #25167A;
		margin-bottom: 0px;
    }

	@media (max-width: 768px) {
		.data-title h3,
		.data-content div {
			font-size: 14px;
		}
	}
</style>